import React, { useState, useEffect } from "react";
import yayinlarbir from "./../img/yayinlar1.png";
import yayinlariki from "./../img/yayinlar2.png";
import yayinlaruc from "./../img/yayinlar3.png";
import yayinlardort from "./../img/yayinlar4.png";
import downloadbtn from "./../img/downloadbtn.png";
import "./../styles/MonthlyPublish.scss";
import Api from "../common/api";

const MonthlyPublish = () => {
  const [datas, setData] = useState([]);
  const [years, setYears] = useState([]);
  const [activeYear, setActiveYear] = useState([]);
  const lang = localStorage.getItem("lang");
  React.useEffect(() => {
    Api.get("/Documents/list/6").then((res) => {
      setData(res.data.items);
      var year = [];
      res.data.items.map((val, index) => {
        var newYear = new Date(val.Create_date.split("(")[1].split(")")[0] * 1)
          .toLocaleDateString("tr-TR")
          .split(".")[2];
        if (year.findIndex((x) => x.name == newYear) == -1) {
          year.push({
            id: index,
            name: newYear,
          });
        }
      });
      setYears(year);
      setActiveYear(year[0].name);
    });
  }, []);

  return (
    <div className="monthly-publish-container">
      <div className="year-tabs">
        <ul className="row-normal">
          {years
            ? years.map((tab) => {
                return (
                  <>
                    <li
                      className={
                        tab.name === activeYear ? "years active" : "years"
                      }
                      onClick={() => {
                        setActiveYear(tab.name);
                      }}
                    >
                      {tab.name}
                    </li>
                  </>
                );
              })
            : null}
        </ul>
      </div>
      <div className="publications-items">
        <div className="publications-container-item">
          {datas
            ? 
            lang == "en" ? (

            datas
                .filter(
                  (x) =>
                    new Date(x.Create_date.split("(")[1].split(")")[0] * 1)
                      .toLocaleDateString("tr-TR")
                      .split(".")[2] == activeYear
                )
                .map((data) => (
                  data.Name_EN && data.Thumb_En ? (
                  <>
                    <a
                      href={"https://sankoenerji.com.tr" + data.File_En}
                      target="_blank"
                      className="monthly-item"
                    >
                      <h1>{lang == "en" ? data.Name_EN : data.Name_TR}</h1>
                      <div className="basliklar">
                        <img
                          className="kapak-foto-blank"
                          src={
                            "https://sankoenerji.com.tr" +
                            data.Thumb_En
                          }
                          alt={data.Name_TR}
                        />
                      </div>
                    </a>
                  </>
                  ):""
                ))
                ):(
                  datas
                  .filter(
                    (x) =>
                      new Date(x.Create_date.split("(")[1].split(")")[0] * 1)
                        .toLocaleDateString("tr-TR")
                        .split(".")[2] == activeYear
                  )
                  .map((data) => (
                    <>
                      <a
                        href={"https://sankoenerji.com.tr" + data.Image}
                        target="_blank"
                        className="monthly-item"
                      >
                        <h1>{lang == "en" ? data.Name_EN : data.Name_TR}</h1>
                        <div className="basliklar">
                          <img
                            className="kapak-foto-blank"
                            src={
                              "https://sankoenerji.com.tr" +
                              data.Document_type
                            }
                            alt={data.Name_TR}
                          />
                        </div>
                      </a>
                    </>
                  ))

                )

            : null}
        </div>
      </div>
    </div>
  );
};

export default MonthlyPublish;
